import { Link } from '@tanstack/react-router';
import { Icon } from './Icon.tsx';
import { useAuthStore } from '../store/auth.ts';
import { NotificationBell } from './NotificationBell.tsx';
import { ThemeToggle } from './ThemeToggle.tsx';
import { dv } from '../i18n/dv.ts';

// Material 3 mobile top app bar. The desktop bar is TopBar.tsx; this one only
// renders below `md`. It sits on the chrome ground (not a translucent blur over
// the content panel) so the frame reads as one tinted surface, as in WapSign.
export function Header(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  return (
    <header
      className="md:hidden sticky top-0 z-30 flex items-center justify-between gap-3 px-3 py-2 bg-[hsl(var(--chrome))]"
      style={{ paddingTop: 'calc(0.5rem + env(safe-area-inset-top))' }}
    >
      <Link to="/" className="flex min-w-0 items-center gap-2.5 ps-1">
        <img
          src="/icons/wapstat-mark.svg"
          alt=""
          className="size-9 shrink-0 rounded-[25%] object-contain"
        />
        <div className="min-w-0">
          <span className="font-serif text-[1.35rem] leading-none text-ink">{dv.appName}</span>
          {user?.orgName && (
            <p className="mono-meta text-muted-foreground truncate text-[0.65rem]">{user.orgName}</p>
          )}
        </div>
      </Link>
      {user && (
        <div className="flex shrink-0 items-center gap-0.5 text-sm">
          {user.isOrgAdmin && (
            <Link
              to="/settings"
              aria-label={dv.nav.settings}
              className="grid size-11 place-items-center rounded-full text-muted-foreground hover:bg-muted/70 transition-colors"
            >
              <Icon name="settings" size={22} />
            </Link>
          )}
          <NotificationBell />
          <ThemeToggle />
        </div>
      )}
    </header>
  );
}
